module.exports = __webpack_public_path__ + "static/media/correct.4023f4ec.jpg";